export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.8b8bc0e9.woff2";